import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { PUBLIC_KEY_V2 } from '../../../Config/app/reCaptcha';

type Props = {
  onChange: (token: string) => void;
  isInvalid: boolean;
};

export const ReCaptchaCheckbox = ({ onChange, isInvalid }: Props) => {
  const id = useRef('');

  useEffect(() => {
    if (id.current !== '') return;

    id.current = window.grecaptcha.render('recaptcha-checkbox', {
      sitekey: PUBLIC_KEY_V2,
      callback: (token: string) => {
        onChange(token);
      },
    });

    return () => {
      window.grecaptcha.reset(id.current);
    };
  }, []);

  return (
    <div className={classNames('mt-5 flex justify-center')}>
      <div
        id="recaptcha-checkbox"
        className={classNames({ 'bg-red-500': isInvalid })}
        style={{ borderRadius: '2px', paddingTop: '2px', paddingLeft: '2px' }}
      />
    </div>
  );
};
